<template>
  <div class="loginAll">
    <div class="login">
      <div class="login_top ovh">
        <div class="f_l login_top_img">
          <img src="../../static/registerTop.png" />
        </div>
        <div class="f_r close" @click="close()">
          <img src="../../static/close.png" />
        </div>
      </div>
      <!-- 框 -->
      <div class="frame">
        <div class="ovh">
          <!-- <input class="input" placeholder="请设置用户名" v-model="userName" /> -->
          <input class="input" placeholder="请输入手机号" v-model="tel" maxlength="11" />
        </div>
        <div class="ovh">
          <input class="input f_l" placeholder="请设置登录密码" v-model="pwd" />
          <input class="input f_l" placeholder="请确认登录密码" v-model="pwd_1" />
          <div class="input ovh f_r">
            <input class="input_code f_l" placeholder="请输入验证码" v-model="code" />
            <div class="input_time f_r" @click="getCode">{{timeTxt}}</div>
          </div>
        </div>
        <!-- 隐私协议 -->
        <div class="agreement ovh" @click="agreementClick">
          <input class="f_l checkbox" type="checkbox" v-model="agreementCheckbox" />
          <div class="agreementTxt f_l">
            我已阅读并同意乐冰雪的<span @click="seeAgreement(0)">《用户服务协议》</span>与<span @click="seeAgreement(1)">《隐私协议》</span>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="button" @click="registerSubmit">注册</div>
        <!-- 登录 -->
        <div class="bottom_size" @click="login">已有账号  <span>立即登录</span></div>
      </div>
    </div>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";
  import "../components/css/input.css";

  // 调用的接口
  import { register, getPhoneCode } from '@/request/api.js';

  export default {
    name: 'register',
    data () {
      return {
        userName: '', // 用户名
        tel: '', // 手机号/邮箱
        pwd: '', // 密码
        pwd_1: '', // 密码
        code: '', // 验证码
        time: 60, // 倒计时
        timeTxt: '获取验证码', // 倒计时后缀
        agreementCheckbox: false // 用户是否同意隐私协议
      }
    },

    mounted() {
      
    },

    computed:{
      
    },

    show() {

    },

    methods:{
      // 进入页面执行的操作
      init() {
        
      },

      // 注册
      registerSubmit() {
        // 判断用户是否同意隐私协议
        if(!this.agreementCheckbox) {
          this.$message({
            showClose: true,
            message: '请阅读并同意隐私协议'
          });
          return;
        }
        // 判断密码是否一致
        if(this.pwd !== this.pwd_1) {
          this.$message({
            type: 'error',
            message: '密码不一致，请重新输入'
          });
          return;
        }
        // 调用注册接口
        register({
          account: this.tel, // 手机号
          password: this.pwd, // 密码
          code: this.code // 验证码
        }).then(res => {
          if(res.code === 0) {
            this.$message({
              type: 'success',
              message: '注册成功'
            });
            // 保存用户信息
            localStorage.setItem('userName', res.data.nickname);
            localStorage.setItem('token', res.data.token);
            // 关闭弹框
            this.close(0);
          }else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      },

      // 获取验证码
      getCode() {
        // 判断当前倒计时是否走完
        if(this.timeTxt !== '重新获取' && this.timeTxt !== '获取验证码') {
          this.$message({
            message: '请倒计时完成后再试'
          });
          return;
        }
        // 调用根据手机号获取验证码接口
        getPhoneCode({
          phone: this.tel // 手机号
        }).then(res => {
          if(res.code === 0) {
            this.$message({
              type: 'success',
              message: '发送成功'
            });
            // 倒计时
            this.setTimeCount();
          }else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      },

      // 倒计时
      setTimeCount() {
        var time = this.time;
        var timeText = '';
        time--;
        if (time <= 0) {
          this.time = 60; // 时间赋值
          this.timeTxt =  '重新获取'; // 内容赋值
          return;
        }
        this.time = time; // 时间赋值
        this.timeTxt =  time + '秒'; // 内容赋值
        setTimeout(this.setTimeCount, 1000);
      },

      // 点击tab切换
      tabClick(e) {
        this.tabCode = e.code;
      },

      // 登录
      login() {
        // 关闭弹框
        this.close(1);
      },

      // 用户点击隐私协议
      agreementClick() {
        this.agreementCheckbox = !this.agreementCheckbox;
      },

      // 关闭弹框
      close(code) {
        // 执行父组件的方法
        this.$emit('registerReturn', code)
      },

      // 点击协议
      seeAgreement(code) {
        var url = window.location.href;
        var index = url.lastIndexOf("\/");
        var str = url.substring(0, index + 1);
        localStorage.setItem('agreementCode', code)
        window.open(str + 'agreement');
      },
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .loginAll {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,.5);
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    // 框
    .login {
      width: 644px;
      height: 592px;
      background-color: #FFFFFF;
      border-radius: 8px;
      &> .login_top {
        height: 70px;
        lin-height: 70px;
        background-color: #FF7702;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        padding: 0 16px;
        &> .login_top_img {
          width: 108px;
          height: 24px;
          margin: 23px 0 0 268px;
        }
        &> .close {
          width: 24px;
          height: 24px;
          font-size: 25px;
          line-height: 70px;
          margin-top: 3px;
          cursor: pointer;
        }
      }
      // 框
      &> .frame {
        margin: 0 auto;
        padding: 39px 52px 0 52px;
        &> div {
          width: 344px;
          margin: 0 auto;
        }
        // 隐私协议
        &> .agreement {
          width: 344px;
          margin: 0 auto;
          margin-top: 28px !important;
          cursor: pointer;
          &> .checkbox {
            margin: 1px 8px 0 0;
          }
          &> .agreementTxt {
            font-size: 12px;
            color: #7F7E7D;
            & span {
              color: #0F7DFF;
            }
          }
        }
        // 按钮
        &> .button {
          width: 344px;
          margin: 0 auto;
          margin-top: 12px !important;
          color: #fff;
          background-color: #0F7DFF;
          height: 56px;
          line-height: 56px;
          border-radius: 8px;
          cursor: pointer;
        }
        // 注册
        &> .bottom_size {
          text-align: right;
          line-height: 40px;
          color: #575858;
          letter-spacing: 1px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          &> span {
            color: #0F7DFF;
            cursor: pointer;
          }
        }
      }
    }
  }
  .input {
    font-size: 14px;
    width: 100%;
    height: 56px;
    line-height: 56px;
    border-radius: 8px;
    background: #E2E2E2;
    padding: 0 17px;
    box-sizing: border-box;
    letter-spacing: 1px;
    margin-top: 22px;
  }
  .input_code {
    width: 50%;
    height: 56px;
    line-height: 56px;
    font-size: 14px;
    letter-spacing: 1px;
  }
  .input_time {
    width: 80px;
    color: #0F7DFF;
  }
  input {
    -webkit-text-fill-color: #434444;
  }
</style>



// WEBPACK FOOTER //
// src/components/register.vue